import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import {
    View,
    Text,
    StyleSheet,
    TouchableOpacity,
} from "react-native";
import Width from "../../../assets/Width";
import CustomButton from "../../../commonComponents/CustomButton";
import CustomInput from "../../../commonComponents/CustomInput";
import { Color, globalFontStyle, globalStyle } from "../../../assets";
import {globalConfigurableData, globalConst} from "../../../utils/globalConstant";
import { Network } from "../../../utils/network";
import Colors from "../../../assets/Color/Colors";
import {defaultRange, isMobile, openURL} from "../../../utils/commonMethods";
import {globalFormStyle} from "../../../assets/GlobalStyle/globalFormStyle";
import FormTextLabel from "../../../commonComponents/FormTextLabel";
import {useNavigation} from "@react-navigation/native";
import {INDIA} from "../../../utils/constants";
import {useSelector} from "react-redux";
import FastImage from "../../../common/FastImage";
import {powertrade, powertrade_youtube,} from "../../../utils/images";
import BuySellBalanceSection from "./BuySellBalanceSection";
import colors from "../../../assets/Color/Colors";

const PowerTrade = ({
                          eventDetails,
                          orderStatus,
                          onBottomSheetClose,
                          closeSheet,
                      }) => {
    const navigation = useNavigation();
    const {
        control,
        formState: {errors, isValid, isSubmitting},
        handleSubmit,
        reset,
        watch,
        setError,
        clearErrors,
    } = useForm({mode: 'onChange'});
    const [displayData, setDisplayData] = useState([]);
    const [sharePrice, setSharePrice] = useState(null);


    let userInfo = useSelector(({ profile }) => profile.profileData);
    const globalConfigData = useSelector(
        state => state.utilReducer.globalConfigData,
    );
    const walletBalance = parseFloat(userInfo?.maxTradeableAmount,
    )?.toFixed(2);
    const watchshare = watch("currentShare");


    useEffect(() => {
        reset({
            currentShare: '1000',
        });
    }, []);
    useEffect(() => {
        watchshare && getTotalAmountRecieve();
    }, [watchshare]);

    const prefix = 'prefix-';

    const getTotalAmountRecieve = async () => {
        const instantSharePayload = {
            appVersion: globalConst.appVersion,
            eventId: eventDetails.id,
            amount: watchshare,
            range: defaultRange.end,
        };

        const res = await Network.getPowerTradeShares(instantSharePayload);
        if (res?.data?.success == true) {
            if(res?.data?.data.length !== 0){
                setDisplayData(res?.data?.data);
                setSharePrice(res?.data?.sharePrice);
            }

            clearErrors('registerInput');
        } else {
            setError('registerInput', {type: 'custom', message: res?.data?.error});
        }
    };

    let region = userInfo?.region_code ?? "INDIA";

    const onPlaceOrder = async data => {
        if (!userInfo?.isProfileComplete) {
            isMobile() && closeSheet();
            navigation.navigate('Profile');
            return;
        }
        let inputObj = {
            appVersion: globalConst.appVersion,
            eventId: eventDetails.id,
            amount: watchshare,
            range: defaultRange.end,
        };
        if (!isSubmitting) {
            const res = await Network.PowerTrade(inputObj, true);
            orderStatus(res, false, false, false, true);
        }
    };

    return (
        <View
            style={[
                {
                    // width: Width.width,
                    flex: 1,
                    alignItems: 'stretch',
                    paddingTop: isMobile() ? 0 : 15,
                },
                isMobile() ? {width: Width.width} : null,
            ]}>
                    <View
                        style={{
                            flexDirection: "row",
                            justifyContent: "flex-start",
                            paddingHorizontal: 15,
                            marginBottom: 5,
                            marginTop: 5,
                        }}
                    >
                        <View style={{ flexDirection: "row", flex: 1, alignItems: 'center' }}>
                            <FastImage
                                style={{height : 25, width: 25}}
                                source={powertrade()}
                            />
                            <View style={{ flex: 1, flexDirection: 'column', alignSelf: 'center'}}>
                                <Text
                                    numberOfLines={2}
                                    style={[globalFontStyle.appFontTitle, {
                                        flex: 1,
                                        marginLeft: 5,
                                        color: globalConfigurableData.primaryTextColor1
                                    }]}
                                >
                                    {"Power Trade"}
                                </Text>
                            </View>
                        </View>
                        {globalConfigData?.powerTradeLink ? (
                            <TouchableOpacity
                                style={{
                                    flexDirection: 'row',
                                    paddingVertical: 8,
                                    paddingHorizontal: 10,
                                    backgroundColor: colors.red,
                                    borderRadius: 8,
                                    alignItems: 'center'
                                }}
                                onPress={() => openURL(globalConfigData?.powerTradeLink)}>
                                <FastImage
                                    style={{height : 20, width: 20}}
                                    source={powertrade_youtube()}
                                />
                                <FormTextLabel
                                    labelStyles={[
                                        globalFontStyle.appFontSubText,
                                        {
                                            marginTop: 2,
                                            color: colors.bgWhite,
                                            marginLeft: 5,
                                        },
                                    ]}
                                    label={'How it works?'}
                                />
                            </TouchableOpacity>
                        ) : null}
                    </View>
            <View
                style={{
                    paddingHorizontal: 15,
                    paddingVertical: 5,
                    justifyContent: 'space-between',
                }}>
                <View style={{paddingVertical: 15, paddingBottom: 10}}>
                    <View
                        style={{
                            flexDirection: 'row',
                            justifyContent: 'space-between',
                            marginBottom: 5,
                        }}>
                        <FormTextLabel
                            labelStyles={styles.formTitle}
                            label={'Amount'}
                        />
                    </View>

                    <CustomInput
                        name="currentShare"
                        placeholder=""
                        control={control}
                        rules={{
                            required: true,
                            validate: value => {
                                const amount = parseFloat(value);
                                if (isNaN(amount) || amount < 1000) {
                                    return false;
                                }
                                return true;
                            }
                        }}
                        selectTextOnFocus={true}
                        type={'number'}
                        customStyle={[
                            {textAlign: "left", height: 45, paddingHorizontal: 12, paddingVertical: 0,},
                        ]}
                        isNumberKeyboard={true}
                        isTextAlignLeft={true}
                    />
                </View>
                {errors?.registerInput?.type === 'custom' && (
                    <Text style={globalStyle.errorText}>
                        {errors.registerInput.message}
                    </Text>
                )}
                <BuySellBalanceSection
                    walletBalance={walletBalance}
                />
                <View style={{paddingTop: 10}}>
                    {displayData?.map((item, i) => {
                        return (
                            <View style={{...globalFormStyle.tableContainerRow, paddingTop: 0}}>
                                <View>
                                    <FormTextLabel
                                        labelStyles={{
                                            color: globalConfigurableData.secondaryTextColor1,
                                            ...globalFontStyle.appFontBody,
                                        }}
                                        label={item?.key}
                                    />
                                </View>

                                <Text
                                    style={{
                                        color: globalConfigurableData.secondaryTextColor1,
                                        ...globalFontStyle.appFontBody,
                                    }}>
                                    {' '}
                                    {item?.value}
                                </Text>
                            </View>
                        );
                    })}
                </View>
                <View style={{
                    borderRadius: 8,
                    borderWidth: 1,
                    borderColor: globalConfigurableData.primaryBtnColor,
                    backgroundColor: Colors.tradexBlue1,
                    paddingVertical: 12,
                    marginTop: 20
                }}>
                    <Text
                        style={{
                            ...globalFontStyle.appFontSubText,
                            color: globalConfigurableData.primaryBtnColor,
                            textAlign: "center",
                        }}>
                        {"Share price for both side is " + (defaultRange.end * .5 + ":" + defaultRange.end * .5) + " always"}
                    </Text>
                </View>
                <View
                    style={[
                        globalStyle.customBtnParentModalStyle,
                        {paddingHorizontal: 0, paddingTop:0},
                    ]}>
                    <CustomButton
                        btnText="Confirm Power Trade"
                        btnType={isValid && parseFloat(watchshare) >= 1000 ? 'btnBlack' : 'disableBlack'}
                        onBtnClick={handleSubmit(onPlaceOrder)}
                        translate={true}
                    />
                </View>
            </View>
        </View>
    );
};

export default PowerTrade;

const styles = StyleSheet.create({
    infoStyle: {
        width: 12.5,
        height: 12.5,
    },
    selectedFormTypeBlock: {
        paddingHorizontal: 10,
        borderBottomWidth: 2,
        paddingVertical: 10,
        borderBottomColor: Colors.black,
        alignSelf: 'flex-start',
    },
    formTitle: {
        ...globalFontStyle.appFontSubText,
        color: globalConfigurableData.primaryTextColor1,
    },
});
